import _ from 'lodash'
import '../../../css/svdreact.css'
import '../../../css/dream.css'
import '../../../css/ca.css'
import '../../../css/cm.css'
import Terrain from '../../terrain/Terrain'
import CardTerrain from '../../terrain/CardTerrain'
import TerrainGallery from '../../terrain/TerrainGallery'
import { Link } from "react-router-dom"

import SJCarouselDyna from "../../../views/SJCarouselDyna";

import { Button as SVAButton } from 'antd';
import SJCarousel from "../../../views/SJCarousel";
import {FANCY_DICON,SV_SOJ_ORCMOCK_ADDRESS,SV_SOJ_NOTCAROUSEL_VIEW} from '../../../constants'
import GlassTerrain from '../../terrain/GlassTerrain'
import { noop } from 'react-bootstrap-typeahead/types/utils'
const React = require('react')
class CliDetailContainer extends React.Component {

    constructor(props) {
        super(props)
        let me = this
        this.getCarouselOrPhoto = this.getCarouselOrPhoto.bind(me)
        this.getTriplets = this.getTriplets.bind(me)
        this.drawRow = this.drawRow.bind(me)
        this.drawDayCell = this.drawDayCell.bind(me)
        this.getGgChildContainersDyna = this.getGgChildContainersDyna.bind(me)
        this.getGgBodyDyna = this.getGgBodyDyna.bind(me)

        //this.getGgChildContainers = this.getGgChildContainers.bind(me)
        // this.getChildContainersR1 = this.getChildContainersR1.bind(me)
        this.getGgBody = this.getGgBody.bind(me)
        // this.getCgBodyR1 = this.getCgBodyR1.bind(me)
    }
    getCarouselOrPhoto = (o) =>{
        let ar =  o['imgs']
       let roomImgs =ar
       let roomImg = `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`
       if(roomImgs && (roomImgs.length > 0)) {
            roomImg = roomImgs[0]
       }

       let photoOnly =  SV_SOJ_NOTCAROUSEL_VIEW ? SV_SOJ_NOTCAROUSEL_VIEW :false
       
       if(photoOnly){
                     return  (
                 <div className="gallery">
                     <figure style={{'marginBottom':'0px'}}>
                     <span  >	<Link to={`/svessearch/svredsojourn/${o.space_key}`}> 
                     
                     <img src={`${roomImg}`}  alt="Carpet Grass" />
                     </Link> </span>
                         
                     </figure>
                 </div>)

       }
       //check ar
       if(ar && (ar.length > 2) ){
           let roomImgs = ar.slice(0,6)
         return ( <SJCarouselDyna roomImgs={roomImgs} ></SJCarouselDyna>)

       }else{
           return ( <SJCarousel ></SJCarousel>)
       }

   }
   /*
    getGgChildContainers() {

        return (

            <div id="gfeatures" className="gfeatures section">
                <div className="row ">
                    <div className="col-lg-12">
                        <div className="gfeatures-content">
                            <div className="row">
                                <div className="col-lg-4">
                                    <div className="gfeatures-item first-feature wow fadeInUp animated great-anim" data-wow-duration="1s" data-wow-delay="0s" >
                                        <div className="first-number number">
                                            <h6>01</h6>
                                        </div>
                                        <div className="icon"></div>
                                        <h4>Los Angeles, CA</h4>
                                        <h6>Day 1 - EMBARK AT 4:00 PM</h6>

                                        <div className="line-dec"></div>
                                        <p><SJCarousel ></SJCarousel></p>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="gfeatures-item second-feature wow fadeInUp animated great-anim-2" data-wow-duration="1s" data-wow-delay="0.2s" >
                                        <div className="second-number number">
                                            <h6>02</h6>
                                        </div>
                                        <div className="icon"></div>
                                        <h4>At Sea</h4>
                                        <h6>Day 2: About At Sea Day (Cruising)</h6>
                                        <div className="line-dec"></div>
                                        <p><SJCarousel ></SJCarousel></p>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="gfeatures-item first-feature wow fadeInUp animated  great-anim-4" data-wow-duration="1s" data-wow-delay="0.4s" >
                                        <div className="third-number number">
                                            <h6>03</h6>
                                        </div>
                                        <div className="icon"></div>
                                        <h4>Day3 : At Sea</h4>
                                        <h6>About At Sea Day (Cruising)</h6>
                                        <div className="line-dec"></div>
                                        <p><SJCarousel ></SJCarousel></p>
                                    </div>
                                </div>
                               
                            </div>
                        </div>

                    </div>
                </div>
                <div className="row sv-cli-gap">
                    <div className="col-lg-12">
                        <div className="gfeatures-content">
                            <div className="row">
                                <div className="col-lg-4">
                                    <div className="gfeatures-item first-feature wow fadeInUp animated great-anim" data-wow-duration="1s" data-wow-delay="0s" >
                                        <div className="first-number number">
                                            <h6>04</h6>
                                        </div>
                                        <div className="icon"></div>
                                        <h4>Los Angeles, CA</h4>
                                        <h6>Day 4 - EMBARK AT 4:00 PM</h6>

                                        <div className="line-dec"></div>
                                        <p><SJCarousel ></SJCarousel></p>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="gfeatures-item second-feature wow fadeInUp animated great-anim-2" data-wow-duration="1s" data-wow-delay="0.2s" >
                                        <div className="second-number number">
                                            <h6>05</h6>
                                        </div>
                                        <div className="icon"></div>
                                        <h4>At Sea</h4>
                                        <h6>Day 5: About At Sea Day (Cruising)</h6>
                                        <div className="line-dec"></div>
                                        <p><SJCarousel ></SJCarousel></p>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="gfeatures-item first-feature wow fadeInUp animated  great-anim-4" data-wow-duration="1s" data-wow-delay="0.4s" >
                                        <div className="third-number number">
                                            <h6>06</h6>
                                        </div>
                                        <div className="icon"></div>
                                        <h4>Day6 : At Sea</h4>
                                        <h6>About At Sea Day (Cruising)</h6>
                                        <div className="line-dec"></div>
                                        <p><SJCarousel ></SJCarousel></p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="row sv-cli-gap">
                    <div className="col-lg-12">
                        <div className="gfeatures-content">
                            <div className="row">
                                <div className="col-lg-4">
                                    <div className="gfeatures-item first-feature wow fadeInUp animated great-anim" data-wow-duration="1s" data-wow-delay="0s" >
                                        <div className="first-number number">
                                            <h6>07</h6>
                                        </div>
                                        <div className="icon"></div>
                                        <h4>Los Angeles, CA</h4>
                                        <h6>Day 7 - EMBARK AT 4:00 PM</h6>

                                        <div className="line-dec"></div>
                                        <p><SJCarousel ></SJCarousel></p>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="gfeatures-item second-feature wow fadeInUp animated great-anim-2" data-wow-duration="1s" data-wow-delay="0.2s" >
                                        <div className="second-number number">
                                            <h6>08</h6>
                                        </div>
                                        <div className="icon"></div>
                                        <h4>At Sea</h4>
                                        <h6>Day 8: About At Sea Day (Cruising)</h6>
                                        <div className="line-dec"></div>
                                        <p><SJCarousel ></SJCarousel></p>
                                    </div>
                                </div>
                               

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }
    */
    getGgBody() {
        const lastestUpdateDate = 'Data Refresh Daily'
        return this.getGgChildContainers()
    }
    getGgBodyDyna(mtar) {
        const lastestUpdateDate = 'Data Refresh Daily'
        return this.getGgChildContainersDyna(mtar)
    }

    render() {

        console.log('svrender', this.props)
        const { my_data, svexcursion } = this.props
        let  exSchedule= null
/*
        let  exSchedule= [
            {
                "id": 0,
                "day": 1,
                "date": "2026-05-07T00:00:00+00:00",
                "portCode": "SEA",
                "port": "Seattle",
                "portOverviewDescription": null,
                "arrive": null,
                "depart": "2026-05-07T15:30:00+00:00",
                "dateDayOfWeek": "Thu",
                "dateDayOfWeekFull": "Thursday",
                "arriveTimeHMmTt": "10:30 AM",
                "arriveDayOfWeek": null,
                "arriveDayOfWeekFull": null,
                "departTimeHMmTt": "3:30 PM",
                "departDayOfWeek": "Thu",
                "departDayOfWeekFull": "Thursday"
            },
            {
                "id": 1,
                "day": 2,
                "date": "2026-05-08T00:00:00+00:00",
                "portCode": "FS1",
                "port": "Fun Day At Sea",
                "portOverviewDescription": null,
                "arrive": null,
                "depart": null,
                "dateDayOfWeek": "Fri",
                "dateDayOfWeekFull": "Friday",
                "arriveTimeHMmTt": null,
                "arriveDayOfWeek": null,
                "arriveDayOfWeekFull": null,
                "departTimeHMmTt": null,
                "departDayOfWeek": null,
                "departDayOfWeekFull": null
            },
            {
                "id": 2,
                "day": 3,
                "date": "2026-05-09T00:00:00+00:00",
                "portCode": "TFJ",
                "port": "Cruise Tracy Arm Fjord",
                "portOverviewDescription": null,
                "arrive": null,
                "depart": null,
                "dateDayOfWeek": "Sat",
                "dateDayOfWeekFull": "Saturday",
                "arriveTimeHMmTt": "10:30 AM",
                "arriveDayOfWeek": null,
                "arriveDayOfWeekFull": null,
                "departTimeHMmTt": "5:30 PM",
                "departDayOfWeek": null,
                "departDayOfWeekFull": null
            },
            {
                "id": 3,
                "day": 4,
                "date": "2026-05-10T00:00:00+00:00",
                "portCode": "SKY",
                "port": "Skagway",
                "portOverviewDescription": null,
                "arrive": "2026-05-10T07:00:00+00:00",
                "depart": "2026-05-10T20:00:00+00:00",
                "dateDayOfWeek": "Sun",
                "dateDayOfWeekFull": "Sunday",
                "arriveTimeHMmTt": "7:00 AM",
                "arriveDayOfWeek": "Sun",
                "arriveDayOfWeekFull": "Sunday",
                "departTimeHMmTt": "8:00 PM",
                "departDayOfWeek": "Sun",
                "departDayOfWeekFull": "Sunday"
            },
            {
                "id": 4,
                "day": 5,
                "date": "2026-05-11T00:00:00+00:00",
                "portCode": "JNU",
                "port": "Juneau",
                "portOverviewDescription": null,
                "arrive": "2026-05-11T07:00:00+00:00",
                "depart": "2026-05-11T15:00:00+00:00",
                "dateDayOfWeek": "Mon",
                "dateDayOfWeekFull": "Monday",
                "arriveTimeHMmTt": "7:00 AM",
                "arriveDayOfWeek": "Mon",
                "arriveDayOfWeekFull": "Monday",
                "departTimeHMmTt": "3:00 PM",
                "departDayOfWeek": "Mon",
                "departDayOfWeekFull": "Monday"
            },
            {
                "id": 5,
                "day": 6,
                "date": "2026-05-12T00:00:00+00:00",
                "portCode": "KTN",
                "port": "Ketchikan",
                "portOverviewDescription": null,
                "arrive": "2026-05-12T07:00:00+00:00",
                "depart": "2026-05-12T13:00:00+00:00",
                "dateDayOfWeek": "Tue",
                "dateDayOfWeekFull": "Tuesday",
                "arriveTimeHMmTt": "7:00 AM",
                "arriveDayOfWeek": "Tue",
                "arriveDayOfWeekFull": "Tuesday",
                "departTimeHMmTt": "1:00 PM",
                "departDayOfWeek": "Tue",
                "departDayOfWeekFull": "Tuesday"
            },
            {
                "id": 6,
                "day": 7,
                "date": "2026-05-13T00:00:00+00:00",
                "portCode": "YYJ",
                "port": "Victoria",
                "portOverviewDescription": null,
                "arrive": "2026-05-13T20:00:00+00:00",
                "depart": "2026-05-13T23:59:00+00:00",
                "dateDayOfWeek": "Wed",
                "dateDayOfWeekFull": "Wednesday",
                "arriveTimeHMmTt": "8:00 PM",
                "arriveDayOfWeek": "Wed",
                "arriveDayOfWeekFull": "Wednesday",
                "departTimeHMmTt": "11:59 PM",
                "departDayOfWeek": "Wed",
                "departDayOfWeekFull": "Wednesday"
            },
            {
                "id": 7,
                "day": 8,
                "date": "2026-05-14T00:00:00+00:00",
                "portCode": "SEA",
                "port": "Seattle",
                "portOverviewDescription": null,
                "arrive": "2026-05-14T07:00:00+00:00",
                "depart": null,
                "dateDayOfWeek": "Thu",
                "dateDayOfWeekFull": "Thursday",
                "arriveTimeHMmTt": "7:00 AM",
                "arriveDayOfWeek": "Thu",
                "arriveDayOfWeekFull": "Thursday",
                "departTimeHMmTt": null,
                "departDayOfWeek": null,
                "departDayOfWeekFull": null
            }
        ]

        */
        if(svexcursion && svexcursion && svexcursion.exSchedules  && (svexcursion.exSchedules.length >0 )){
            exSchedule = svexcursion.exSchedules
        }

        if(svexcursion && svexcursion.exTrip && svexcursion.exTrip.exSchedule  && (svexcursion.exTrip.exSchedule.length >0 )){
            exSchedule = svexcursion.exTrip.exSchedule
        }
        if(exSchedule && (exSchedule.length > 0)){
            console.log('swe are for shedules')

        }else{
            console.log('sv** DEC20**8 getting errors exSchdule array')
            return (
                <noop>
    
    
                    <div className="col-md-12">
                       <h1>Loadibg...</h1>
    
    
                    </div>
                </noop>
            )
        }

        let mtar = this.getTriplets(exSchedule)
        console.log("**triplets**DEC17 ****saatrt")
        console.log(mtar)
        console.log("**triplets**DEC17 ****end")
        return (
            <noop>


                <div className="col-md-12">
                    {
                        this.getGgBodyDyna(mtar)
                    }


                </div>
            </noop>
        )

    }
  
    getTriplets(ar){
       let rmap = {}, o =null
       let rob = {}
       let triplet = []
       let n =0, nstart = 0,nlastday =0;
       let r = 0
       console.log('size of sceduts: ',  ar.length)
       nlastday = ar.length
        for(let i=0; i < ar.length; i++){
            n = i +1;
            if( i != 0){
                if((n %3)  === 0){
                    
                    //reset
                    //store
                    /*
                    rob = {
                        'start':0,
                        'tarp': triplet
                    } */
                    rmap['r' + r] = {
                        'start': nstart,
                        'nlastday':nlastday,
                        'tarp': triplet
                    }
                    //reseet
                    triplet = []
                    r = r + 1;
                    nstart = nstart + 3
                }
            }
            
           
            triplet.push(ar[i])
          
           
        }
        let lastRow = r + 1
       // _.keys(rmap)
        rmap['r' + lastRow] = {
            'start': nstart,
            'nlastday':nlastday,
            'tarp': triplet
        }
        return rmap;
    }
    /*
    getGgChildContainers_dyna(my_data) {
        return my_data.map((o,i) => {
            let n = i+1
            let dn = `01`
            let colNum = i % 3

            if(n < 10){
                dn = `0${n}`
            }else{
                dn = `${n}`
            }
            console.log(o)
            return (
         <div className="row sv-cli-gap">
            <div className="col-lg-12">
                <div className="gfeatures-content">
                    <div className="row">
                        <div className="col-lg-4">
                            <div className="gfeatures-item first-feature wow fadeInUp animated great-anim" data-wow-duration="1s" data-wow-delay="0s" >
                                <div className="first-number number">
                                    <h6>{dn}</h6>
                                </div>
                                <div className="icon"></div>
                                <h4>Los Angeles, CA</h4>
                                <h6>Day {dn} - EMBARK AT 4:00 PM</h6>

                                <div className="line-dec"></div>
                                <p><SJCarousel ></SJCarousel></p>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="gfeatures-item second-feature wow fadeInUp animated great-anim-2" data-wow-duration="1s" data-wow-delay="0.2s" >
                                <div className="second-number number">
                                    <h6>05</h6>
                                </div>
                                <div className="icon"></div>
                                <h4>At Sea</h4>
                                <h6>Day 5: About At Sea Day (Cruising)</h6>
                                <div className="line-dec"></div>
                                <p><SJCarousel ></SJCarousel></p>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="gfeatures-item first-feature wow fadeInUp animated  great-anim-4" data-wow-duration="1s" data-wow-delay="0.4s" >
                                <div className="third-number number">
                                    <h6>06</h6>
                                </div>
                                <div className="icon"></div>
                                <h4>Day6 : At Sea</h4>
                                <h6>About At Sea Day (Cruising)</h6>
                                <div className="line-dec"></div>
                            
                                <p><SJCarousel ></SJCarousel></p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div> )
        });

    }
*/
    drawRow(tmap,rowKey){
        let tarpOb=null, tarp = [], startNum =0, nlastday=0
        /* owKey = "r1" */
        tarpOb= tmap[rowKey]
        tarp = tarpOb['tarp']
        startNum = tarpOb['start']
        nlastday =  tarpOb['nlastday']
        console.log('Dec18******tarpOb', tarpOb)
        console.log('Dec18******nlastday', nlastday)

        return (
            <div className="row sv-cli-gap">
               <div className="col-lg-12">
                   <div className="gfeatures-content">
                       <div className="row">
                           
                           {this.drawDayCells(tarp,startNum , nlastday)}
                          
   
                       </div>
                   </div>
               </div>
           </div> )
    }
    drawDayCell(obcell, dn, nlastday){
        const {arrive, depart,portCode ,arriveTimeHMmTt,departTimeHMmTt } = obcell
        let myfeature,mynumber
        let artime =  arriveTimeHMmTt ? arriveTimeHMmTt : '4:00 PM'
        let sdayWeek = obcell.dateDayOfWeek ?  obcell.dateDayOfWeek : 'NA'
        let  prefix = '',haltSpan, haltStart, haltEnd
        
       
        if(  obcell.portCode != 'FS1'){
            haltStart = arriveTimeHMmTt ? arriveTimeHMmTt : 'XX:00 AM'
            haltEnd =  departTimeHMmTt ?  departTimeHMmTt: 'YY:00 PM'
            haltSpan = `${haltStart} - ${haltEnd}`
        }else{
            haltStart = ''
            haltEnd = ''
            haltSpan = ''
        }
        
        if(dn === 0){
            prefix = ' EMBARK AT'
            haltSpan = `${haltStart}`
        }else if( dn === nlastday){
            prefix = ' DISEMBARK AT'
            haltSpan = `${haltStart}`
        }
        if( FANCY_DICON[''+ dn] && (FANCY_DICON[''+ dn]['fe'])){
            myfeature = FANCY_DICON[''+ dn]['fe']? FANCY_DICON[''+ dn]['fe'] :"first-feature"
        }else{
            myfeature = "first-feature"
        }
        let cn= `gfeatures-item ${myfeature} wow fadeInUp animated great-anim`
        mynumber = FANCY_DICON[''+ dn]['fe']?FANCY_DICON[''+ dn] :"first-number"

        return ( 
    <div className="col-lg-4">
        <div className={cn} data-wow-duration="1s" data-wow-delay="0s" >
            <div className="first-number number">
                <h6>{obcell.day}</h6>
            </div>
            <div className="icon"></div>
            <h4>{obcell.port} ({obcell.portCode}) {dn}</h4>
            <h6>Day {obcell.day} - {prefix} {haltSpan} {sdayWeek}</h6>

            <div className="line-dec"></div>
            <p>
                {this.getCarouselOrPhoto(obcell)}
                {/*   
                <SJCarousel ></SJCarousel>
                */}
            </p>
        </div>
    </div>)
    }

    drawDayCells(my_data, start, nlastday){
        let me = this
        return my_data.map((o,n) => {
            let dn = start + n
            console.log(o)
            console.log('Dec18***nlastday by drawDayCells:',nlastday)
            return me.drawDayCell(o, dn, nlastday)
        });

    }
/*
    getGgChildContainersDyna_svabk(mtar) {
        let r0 = 'r0'
        let r1 = 'r1'
        let r2 = 'r2'
        let allKeys = _.keys(mtar )
        return (

            <div id="gfeatures" className="gfeatures section">
                <div className="row ">
                    <div className="col-lg-12">
                        <div className="gfeatures-content">
                            <div className="row">
                                <div className="col-lg-4">
                                    <div className="gfeatures-item first-feature wow fadeInUp animated great-anim" data-wow-duration="1s" data-wow-delay="0s" >
                                        <div className="first-number number">
                                            <h6>01</h6>
                                        </div>
                                        <div className="icon"></div>
                                        <h4>Los Angeles, CA</h4>
                                        <h6>Day 1 - EMBARK AT 4:00 PM</h6>

                                        <div className="line-dec"></div>
                                        <p><SJCarousel ></SJCarousel></p>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="gfeatures-item second-feature wow fadeInUp animated great-anim-2" data-wow-duration="1s" data-wow-delay="0.2s" >
                                        <div className="second-number number">
                                            <h6>02</h6>
                                        </div>
                                        <div className="icon"></div>
                                        <h4>At Sea</h4>
                                        <h6>Day 2: About At Sea Day (Cruising)</h6>
                                        <div className="line-dec"></div>
                                        <p><SJCarousel ></SJCarousel></p>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="gfeatures-item first-feature wow fadeInUp animated  great-anim-4" data-wow-duration="1s" data-wow-delay="0.4s" >
                                        <div className="third-number number">
                                            <h6>03</h6>
                                        </div>
                                        <div className="icon"></div>
                                        <h4>Day3 : At Sea</h4>
                                        <h6>About At Sea Day (Cruising)</h6>
                                        <div className="line-dec"></div>
                                        <p><SJCarousel ></SJCarousel></p>
                                    </div>
                                </div>
                                
                            </div>
                        </div>

                    </div>
                </div>
               
                {this.drawRow(mtar, r1 )}
            </div>
        )

    }
*/
    getGgChildContainersDyna(mtar) {
        let r0 = 'r0'
        let r1 = 'r1'
        let r2 = 'r2'
        let allKeys = _.keys(mtar )
        console.log(allKeys)
        return (

            <div id="gfeatures" className="gfeatures section">
              
               
                {
                    allKeys.map( (sRowKey,idx)=>{
                        console.log('key Number', sRowKey)
                        return this.drawRow(mtar, sRowKey )
    
                    })
    
                }
            </div>
        )

    }
}

export default CliDetailContainer
//export default CliDetailContainer